import React from 'react';
import { Card, Typography, Input, Space, Button } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useTheme } from '@/components/common/ThemeProvider';
import { GroupList } from '../components/GroupList';
import { GroupFormDialog } from '../components/GroupFormDialog';
import { useGroup } from '../hooks/use-group';
import { NubGroupDTO } from '../types';

const { Title } = Typography;
const { Search } = Input;

export const GroupManagement: React.FC = () => {
    const { dark } = useTheme();
    const {
        // State
        groups,
        activeGroup,
        accessLevels,
        selectedAccessLevels,
        searchTerm,
        actionMode,
        isModalOpen,
        isLoading,
        error,

        // Actions
        handleGroupAction,
        setModalOpen,
        setSelectedAccessLevels,
        setSearchTerm,

        // CRUD operations
        createGroup,
        updateGroup,
    } = useGroup();

    console.log({isModalOpen });



    // Filter groups based on search term
    const filteredGroups = React.useMemo(() => {
        if (!searchTerm) return groups;

        const searchLower = searchTerm.toLowerCase();
        return groups.filter(group =>
            // @ts-ignore
            group.code.toLowerCase().includes(searchLower) ||
            // @ts-ignore
            group.name.toLowerCase().includes(searchLower) ||
            group.description?.toLowerCase().includes(searchLower) ||
            group.accessLevels?.some(level =>
                // @ts-ignore
                level.name.toLowerCase().includes(searchLower) ||
                // @ts-ignore
                level.code.toLowerCase().includes(searchLower)
            )
        );
    }, [groups, searchTerm]);

    // Handle form submission
    const handleSubmit = async (formData: NubGroupDTO) => {
        try {
            if (actionMode === 'add') {
                await createGroup({
                    ...formData,
                    // @ts-ignore
                    accessLevels: accessLevels.filter(al =>
                        // @ts-ignore
                        selectedAccessLevels.includes(al.code)
                    )
                });
            } else if (actionMode === 'edit' && activeGroup) {
                // @ts-ignore
                await updateGroup(activeGroup.code, {
                    ...formData,
                    // @ts-ignore
                    accessLevels: accessLevels.filter(al =>
                        // @ts-ignore
                        selectedAccessLevels.includes(al.code)
                    )
                });
            }
        } catch (error) {
            console.error('Operation failed:', error);
        }
    };

    if (error) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-red-500">
                    Error loading groups: {(error as Error)?.message || 'Unknown error'}
                </div>
            </div>
        );
    }


    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <Title level={2} className={dark ? 'text-white' : ''}>
                    User Group Management
                </Title>

                <Space>
                    <Search
                        placeholder="Search groups..."
                        allowClear
                        enterButton={<SearchOutlined />}
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => handleGroupAction(null, 'add')}
                    >
                        Add User Group
                    </Button>
                </Space>
            </div>

            <Card
                className={dark ? 'bg-gray-800' : ''}
                bordered={false}
                loading={isLoading}
            >
                <GroupList
                    groups={filteredGroups}
                    onGroupAction={handleGroupAction}
                />
            </Card>

            <GroupFormDialog
                open={isModalOpen}
                mode={actionMode}
                initialData={activeGroup}
                accessLevels={accessLevels}
                selectedAccessLevels={selectedAccessLevels}
                onAccessLevelChange={setSelectedAccessLevels}
                onCancel={() => setModalOpen(false)}
                onSubmit={handleSubmit}
            />
        </div>
    );
};